import {
  type OfferDetailsV11,
  type PimProductV13,
  type PrescriptionPrescriptionTypeEnum,
} from '@redteclab/api/clients/bully'

export interface CartIntermediateParams {
  cartAction: 'add'
  drawerId: 'cartIntermediateDrawer' | 'cartIntermediateDrawerBuyTogetherWith'
  eventName:
    | 'addToCart_OfferItem'
    | 'addToCart_PDP'
    | 'addToCart_rx_select_modal'
    | 'addToCart_bought_together'
  eventType: 'conversion'
  isAddProductToCartSuccessful: boolean
  offer?: OfferDetailsV11
  prescriptionType: PrescriptionPrescriptionTypeEnum
  product: PimProductV13
  quantity: number
  reccommendedOffer?: OfferDetailsV11
  recommendedProduct?: PimProductV13
}

export interface CartIntermediateParamsMainCta extends CartIntermediateParams {
  eventName: 'addToCart_OfferItem' | 'addToCart_PDP'
}

export interface CartIntermediateParamsBuyTogetherWith
  extends CartIntermediateParams {
  eventName: 'addToCart_bought_together'
  recommendedOffer?: OfferDetailsV11
  recommendedProduct?: PimProductV13
}

export const makeParamsForCartIntermediate = ({
  isAddProductToCartSuccessful,
  offer,
  prescriptionType,
  product,
  quantity,
}: {
  isAddProductToCartSuccessful: boolean
  offer?: OfferDetailsV11
  prescriptionType: PrescriptionPrescriptionTypeEnum
  product: PimProductV13
  quantity?: number
}): CartIntermediateParamsMainCta => {
  return {
    cartAction: 'add',
    drawerId: 'cartIntermediateDrawer',
    eventName: 'addToCart_PDP',
    eventType: 'conversion',
    isAddProductToCartSuccessful,
    offer,
    prescriptionType,
    product,
    quantity: quantity ?? 1,
  }
}

export const makeParamsForBuyTogetherWith = ({
  isAddProductToCartSuccessful,
  offer,
  prescriptionType,
  product,
  quantity,
  recommendedOffer,
  recommendedProduct,
}: {
  isAddProductToCartSuccessful: boolean
  offer?: OfferDetailsV11
  prescriptionType: PrescriptionPrescriptionTypeEnum
  product: PimProductV13
  quantity?: number
  recommendedOffer?: OfferDetailsV11
  recommendedProduct?: PimProductV13
}): CartIntermediateParamsBuyTogetherWith => {
  return {
    cartAction: 'add',
    drawerId: 'cartIntermediateDrawerBuyTogetherWith',
    eventName: 'addToCart_bought_together',
    eventType: 'conversion',
    isAddProductToCartSuccessful,
    offer,
    prescriptionType,
    product,
    quantity: quantity ?? 1,
    recommendedOffer,
    recommendedProduct,
  }
}
